import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ResizeObserver loop errors are suppressed in public/index.html before the bundle loads so
// react-error-overlay does not register first and still show the red screen. Fallback here
// for environments that omit that script (e.g. some test runners).
window.addEventListener(
  'error',
  (event) => {
    const m = event?.message || event?.error?.message || '';
    if (typeof m === 'string' && m.includes('ResizeObserver loop')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
